module.exports = __webpack_public_path__ + "04840a17ec94aed0935185973ef5d663.svg";